
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';



const getAll = async ( params = {}) => {

  const query = `
    query GetAllLabos(
      $establecimiento: ID
      $search   : String
      $tokenLab : String
      $area     : ID
      $page     : Int
      $pageSize : Int
    ) {
      getAllLabos(
        establecimiento: $establecimiento
        search   : $search
        tokenLab : $tokenLab
        area     : $area
        page     : $page
        pageSize : $pageSize
      ) {
          laboratorio {
            id
            token
            codigo
            descripcion
            precioJson
            estadoJson
            areaanalisis {
              id
              descripcion
            }
            establecimiento

            usuarioCreador {
              id
              username
            }
          }

        total
        status
        message
      }
    }
  `;

  const variables = {
    ...params
  };

  try{
    const response = await axios.post( rutas.axios + 'api', { query, variables } );
    if(response.status !== 200) return null;

    const response2 = response?.data?.data?.getAllLabos;
    if(!response2 || response2.status !== 'Success') return null;


    const data = {
      total        : response2.total,
      laboratorios : response2.laboratorio
    }

    return data;
  }catch(error){
    console.error("Error al buscar los laboratorios:", error);
    return {
      total: 0,
      laboratorios: [],
      error
    };
  }
}


const modificarEstadoMultiples = async (idsLaboratorios, estado) => {

  if(!idsLaboratorios || !estado){
    console.error('No se proporcionaron IDs de laboratorio o estado.');
    return null; 
  }

  const query = ` 
    mutation cambiarEstadoLaboratorio(
      $laboratorioDatos: LaboratorioEstadoInput!
    ) {
      cambiarEstadoLaboratorio(
        laboratorioDatos: $laboratorioDatos
      ) {
        status
        message
      }
    }
  `;

  const variables = {
    laboratorioDatos: {
      id    : idsLaboratorios,
      estado: estado,
    }
  }

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    return true
  }catch(error){
    console.error("Error al actualizar el laboratorio:", error);
    return null
  }
}


const modificarAreaMultiples = async (idLaboratorios, idArea) => {

  if(!idLaboratorios || !idArea){
    console.error('No se proporcionaron IDs de laboratorio o estado.');
    return null; 
  }

  const query = `
    mutation ModificarAreaMultiples(
      $idArea:ID!
      $idLaboratorios:[ID]!
    ) {
      modificarAreaMultiples(
        idArea: $idArea, 
        idLaboratorios: $idLaboratorios
      ) {
        status
        message
      }
    }
  `;

  const variables = {
    idLaboratorios,
    idArea
  };

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.modificarAreaMultiples;
    if(response2.status !== 'success') return null;

    return true;

  }catch(error){
    console.error('Error al actualizar el laboratorio:', error);
    return null;
  }

}


const ModificarEstabLaboratorios = async (idLaboratorios, idEstablecimiento) => {

  if(!idLaboratorios || !idEstablecimiento){
    console.error('No se proporcionaron IDs de laboratorio o establecimiento.');
    return null; 
  }

  const query = `
    mutation ModificarEstabLaboratorios(
      $idLaboratorios:[ID]!
      $idEstablecimiento:ID!
    ) {
      modificarEstabLaboratorios(
        idEstablecimiento: $idEstablecimiento, 
        idLaboratorios: $idLaboratorios
      ) {
        status
        message
      }
    }
  `;

  const variables = {
    idLaboratorios,
    idEstablecimiento
  };

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;
    const response2 = response.data.data.modificarEstabLaboratorios;

    if(response2.status !== 'success') return null;
    return true;

  }catch(error){
    console.error('Error al actualizar el laboratorio:', error);
    return null;
  }
  
}



const createItem = async (dataLaboratorio) => {


  const query = `
    mutation RegistrarLaboratorio(
      $establecimiento:String!
      $codigo:String!
      $descripcion:String!
      $area:String!
      $estados:String!
      $precios:String!
    ) {
      registrarLaboratorio(
        establecimiento : $establecimiento
        codigo          : $codigo
        descripcion     : $descripcion
        area            : $area
        estados         : $estados
        precios         : $precios
      ) {
        laboratorioCreado {
          id
          token
        }
        status
        message
      }
    }
  `;

  const variables = {
    ...dataLaboratorio
  }

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.registrarLaboratorio;
    if(response2.status !== 'success') return null;

    return response2.laboratorioCreado;
  }catch(error){
    console.error("Error al buscar los laboratorios:", error);
    return null;
  }
}



const updateItem = async (dataLaboratorio) => {

  const query = `
    mutation ActualizarLaboratorio(
      $id              : ID!
      $establecimiento : String!
      $descripcion     : String
      $codigo          : String
      $area            : String
      $estados         : String
      $precios         : String
    ) {
      actualizarLaboratorio(
        id              : $id
        establecimiento : $establecimiento
        descripcion     : $descripcion
        codigo          : $codigo
        area            : $area
        estados         : $estados
        precios         : $precios
      ) {
        message
        status
        laboratorioActualizado {
          id
        }
      }
    }
  `;

  const variables = {
    ...dataLaboratorio
  };

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.actualizarLaboratorio;
    if(response2.status !== 'success') return null;

    const data = response2.laboratorioActualizado;
    return data;

  }catch(error){
    console.error("Error al actualizar el laboratorio:", error);
    return null;
  }
}



export const carteraLaboratorioService = {
  getAll,
  createItem,
  updateItem,
  modificarEstadoMultiples,
  modificarAreaMultiples,
  ModificarEstabLaboratorios
}
